import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/emoji.png'


const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "right-wrap" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "tab-nav" }
const _hoisted_5 = { class: "leftitem" }
const _hoisted_6 = { class: "rightitem" }
const _hoisted_7 = { class: "content-tabs" }
const _hoisted_8 = {
  key: 0,
  class: "tab-pane"
}
const _hoisted_9 = { class: "article-list" }
const _hoisted_10 = { class: "article-content" }
const _hoisted_11 = {
  key: 0,
  class: "audit-fail"
}
const _hoisted_12 = {
  key: 1,
  class: "audit-ing"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "article-meta" }
const _hoisted_15 = { class: "article-actions" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "article-creator pagination" }
const _hoisted_18 = {
  key: 0,
  class: "infor-list"
}
const _hoisted_19 = {
  key: 1,
  class: "tab-pane"
}
const _hoisted_20 = { class: "article-list" }
const _hoisted_21 = { class: "article-content" }
const _hoisted_22 = { class: "article-meta" }
const _hoisted_23 = { class: "article-actions" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "article-creator pagination" }
const _hoisted_26 = {
  key: 0,
  class: "infor-list"
}

import { ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import axiosInstance from "@/utils/axiosInstance";
import { WebSite_Name } from "@/interface/globalindex";

import { useHead } from '@vueuse/head'

interface ArticleDraft {
  drafts_id: string;
  title: string;
  created_at: string;
}
interface ArticleInfo {
  article_id: string;
  title: string;
  created_at: string;
  audit_status: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ContentArticle',
  setup(__props) {

const SSRData = ref({
  title: '内容管理 - 创作者中心 - '+WebSite_Name,
  description: '默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。',
  keywords: '默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区'
})

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: 'description', content: SSRData.value.description },
    { name: 'keywords', content: SSRData.value.keywords }
  ]
})

// 定义当前选中的标签，初始值为 'all'
const activeTab = ref<string>("all");
const QueryTitle = ref("");

//草稿箱
const articledrafts = ref<ArticleDraft[]>([]);

//正式发布
const articleinfo = ref<ArticleInfo[]>([]);

const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);

// 获取文章信息列表
const fetchArticleInfoData = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/ArticleInfo/ArticleInfoList",
      {
        params: {
          page: currentPage.value,
          querytitle: QueryTitle.value,
        },
      }
    );
    var result = response.data;
    if (result.success) {
      articleinfo.value = result.data.data;
      total.value = result.data.dataCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
// 当前页变化处理
const handleCurrentChange = (newPage: number) => {
  currentPage.value = newPage;
  fetchArticleInfoData();
};

// 获取草稿箱
const fetchDraftsData = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/ArticleDrafts/ArticleDraftsList",
      {
        params: {
          page: currentPage.value,
          querytitle: QueryTitle.value,
        },
      }
    );
    var result = response.data;
    if (result.success) {
      articledrafts.value = result.data.data;
      total.value = result.data.dataCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
// 当前页变化处理
const handleDraftsChange = (newPage: number) => {
  currentPage.value = newPage;
  fetchDraftsData();
};

onMounted(() => {
  fetchArticleInfoData();
});
//关键字搜索
const querysearch = () => {
  fetchArticleInfoData();
};
//
const activeTabClick = (tab: any) => {

  const tabName = tab.paneName;
  activeTab.value = tabName; // 手动更新激活标签
  currentPage.value = 1;
  total.value = 0;
  if (tabName === "all") {
    fetchArticleInfoData();
  } else if (tabName === "drafts") {
    fetchDraftsData();
  }
};

//删除草稿箱
const handleDraftsDelete = async (draftsid: string) => {
  try {
    await ElMessageBox.confirm("删除内容后不可恢复，确定删除吗？", "删除内容", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
    });

    const response = await axiosInstance.get(
      "/api/ArticleDrafts/ArticleDraftsDelete",
      { params: { drafts_id: draftsid } }
    );
    var result = response.data;
    if (result.success) {
      ElMessage.success("删除成功");
      fetchDraftsData();
    } else {
      ElMessage.error("删除失败");
    }
  } catch (error) {
    console.log("取消删除");
  }
};

//删除文章信息
const handleArticleInfoDelete = async (articleid: string) => {
  try {
    await ElMessageBox.confirm("删除内容后不可恢复，确定删除吗？", "删除内容", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
    });

    const response = await axiosInstance.get(
      "/api/ArticleInfo/ArticleInfoDelete",
      { params: { article_id: articleid } }
    );
    var result = response.data;
    if (result.success) {
      ElMessage.success("删除成功");
      fetchArticleInfoData();
    } else {
      ElMessage.error("删除失败");
    }
  } catch (error) {
    console.log("取消删除");
  }
};

// 编辑处理
// const handleEdit = (articleId: string) => {
//   router.push({
//     name: 'EditorDrafts',  // 确保路由配置了name和参数接收
//     params: { article_id: articleId }
//   })
// }

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "creator-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(CreatorHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CreatorSidebar),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_tabs, {
                      onTabClick: activeTabClick,
                      "model-value": activeTab.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "内容",
                          name: "all",
                          style: {"font-size":"18px"}
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "草稿箱",
                          name: "drafts"
                        })
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_input, {
                      modelValue: QueryTitle.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((QueryTitle).value = $event)),
                      placeholder: "请输入标题关键字",
                      class: "search-input"
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "rightitem-inputsearch",
                          onClick: querysearch
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Search))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (activeTab.value === 'all')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleinfo.value, (infoitem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "article-item",
                                key: infoitem.article_id
                              }, [
                                _createElementVNode("div", _hoisted_10, [
                                  (infoitem.audit_status == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 未通过 "))
                                    : _createCommentVNode("", true),
                                  (infoitem.audit_status == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 待审核 "))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    href: `/post/${infoitem.article_id}`,
                                    target: "_blank"
                                  }, [
                                    _createElementVNode("h3", null, _toDisplayString(infoitem.title), 1)
                                  ], 8, _hoisted_13),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("span", null, _toDisplayString(infoitem.created_at), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_el_dropdown, null, {
                                    dropdown: _withCtx(() => [
                                      _createVNode(_component_el_dropdown_menu, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_dropdown_item, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: `/editor/drafts/${infoitem.article_id}`,
                                                target: "_blank"
                                              }, "编辑", 8, _hoisted_16)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_el_dropdown_item, {
                                            onClick: ($event: any) => (
                                  handleArticleInfoDelete(infoitem.article_id)
                                )
                                          }, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                              _createTextVNode("删除")
                                            ])),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, { text: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_MoreFilled)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_el_pagination, {
                                background: "",
                                "hide-on-single-page": true,
                                layout: "prev, pager, next",
                                "current-page": currentPage.value,
                                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
                                "page-size": pageSize.value,
                                "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event)),
                                total: total.value,
                                onCurrentChange: handleCurrentChange
                              }, null, 8, ["current-page", "page-size", "total"])
                            ]),
                            (total.value ==0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[6] || (_cache[6] = [
                                  _createElementVNode("div", { class: "content-flag" }, [
                                    _createElementVNode("div", { class: "common-empty" }, [
                                      _createElementVNode("img", { src: _imports_0 })
                                    ]),
                                    _createElementVNode("div", { class: "emoji-empty" }, " 连emoji都选择微笑的空白区 ")
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (activeTab.value === 'drafts')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articledrafts.value, (draftsitem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "article-item",
                              key: draftsitem.drafts_id
                            }, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("h3", null, _toDisplayString(draftsitem.title), 1),
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("span", null, _toDisplayString(draftsitem.created_at), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_el_dropdown, null, {
                                  dropdown: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_menu, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_item, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("a", {
                                              href: `/editor/drafts/${draftsitem.drafts_id}`,
                                              target: "_blank"
                                            }, "编辑", 8, _hoisted_24)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_dropdown_item, {
                                          onClick: ($event: any) => (handleDraftsDelete(draftsitem.drafts_id))
                                        }, {
                                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode("删除")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, { text: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_MoreFilled)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_el_pagination, {
                              background: "",
                              "hide-on-single-page": true,
                              layout: "prev, pager, next",
                              "current-page": currentPage.value,
                              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
                              "page-size": pageSize.value,
                              "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pageSize).value = $event)),
                              total: total.value,
                              onCurrentChange: handleDraftsChange
                            }, null, 8, ["current-page", "page-size", "total"])
                          ]),
                          (total.value ==0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[8] || (_cache[8] = [
                                _createElementVNode("div", { class: "content-flag" }, [
                                  _createElementVNode("div", { class: "common-empty" }, [
                                    _createElementVNode("img", { src: _imports_0 })
                                  ]),
                                  _createElementVNode("div", { class: "emoji-empty" }, " 连emoji都选择微笑的空白区 ")
                                ], -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})